import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../services/options.service'

export function* setDispositionOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const dispositionResponse: IOptionsResponse = yield call([optionsService, optionsService.getDispositionOptions])
    yield put(actions.setDispositionOptions(dispositionResponse.entity))

    const unitDispositionResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getUnitDispositionOptions,
    ])
    yield put(actions.setUnitDispositionOptions(unitDispositionResponse.entity))

    const patientEvaluationResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getPatientEvaluationOptions,
    ])
    yield put(actions.setPatientEvaluationOptions(patientEvaluationResponse.entity))

    const crewDispositionResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getCrewDispositionOptions,
    ])
    yield put(actions.setCrewDispositionOptions(crewDispositionResponse.entity))

    const transportDispositionResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getTransportDispositionOptions,
    ])
    yield put(actions.setTransportDispositionOptions(transportDispositionResponse.entity))

    const refusalReleaseResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getRefusalReleaseReasonDispositionOptions,
    ])
    yield put(actions.setRefusalReleaseReasonOptions(refusalReleaseResponse.entity))
  } catch (e) {
    yield put(throwPcrException(`setDispositionOptions() error: ${e}`))
  }
}
export function* setDispositionOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setDispositionOptions)
}
